module.exports = __webpack_public_path__ + "img/def.54658018.svg";